import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate} from "react-router-dom";
import * as OtherCompany from "../index";
import {StoreContext} from "../../../store.context";
import {OtherCompanyPrepareAddFormResponse} from "../../../types/modules/otherCompanu/response";

export const Add: React.FC = observer(() => {
    const { appStore: {
        moduleStore: { otherCompanyStore: { add }},
    }} = useContext(StoreContext);

    const navigate = useNavigate();

    const data: OtherCompanyPrepareAddFormResponse = useLoaderData() as OtherCompanyPrepareAddFormResponse;

    const onCancel = () => {
        navigate(`/other_company`)
    }

    return <OtherCompany.Form onSave={add} onCancel={onCancel} preparedData={data} />
})